import { type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { hasClinicScope } from '@/application/auth/clinicScope';
import { EmptyScopeShell } from '@/presentation/layouts/EmptyScopeShell';
import { useAuth } from '@/presentation/contexts/useAuth';

/** Corta todo el panel autenticado cuando no hay clínicas (US-121). Vive arriba de las rutas. */
export function ClinicScopeBlock({ children }: { children: ReactNode }) {
  const { user, bootstrapping } = useAuth();
  const { pathname } = useLocation();

  if (bootstrapping || !user || pathname === '/login') {
    return children;
  }

  if (!hasClinicScope(user.scope.allowedTenantIds)) {
    return <EmptyScopeShell />;
  }

  return children;
}
